/**
 * Приёмник файлов выгрузки сканов (задача 41): куда браузер складывает архивы команд.
 *
 * Раньше было два режима — «папками» (выбранный каталог через `showDirectoryPicker`,
 * File System Access API) и архивами по командам. 23.10.2026 режим «папками» убран:
 * Chrome на любом выбранном каталоге отвечал «Не удалось открыть папку — она содержит
 * системные файлы» и не давал записать ни одного файла. Выгрузка всегда собирает
 * архивы `<команда>.zip` и отдаёт их браузеру системным скачиванием (`saveFile`).
 *
 * Имя файла — последний сегмент пути выгрузки: папки внутри пути в скачиваниях
 * не участвуют (они существуют внутри архива).
 */
import { saveFile } from './api';

/** Приёмник файлов выгрузки. */
export interface ExportSink {
  /** Отдаёт файл по пути внутри выгрузки (`команда/спортсмен/документ.jpg`). */
  write(path: string, blob: Blob): Promise<void>;
}

/** Единственный приёмник: файл уходит браузеру системным скачиванием по имени. */
export const documentsDownloadSink: ExportSink = {
  async write(path: string, blob: Blob): Promise<void> {
    saveFile(path.split('/').pop() ?? 'документ', blob);
  },
};
